export default __webpack_public_path__ + "static/media/md-arrow-dropup.31eac2c9.svg";